import React, { useState } from "react";
import SignUp from "./Signup.module.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useGoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { signup, signupGoogle } from "../../redux/actions/auth";


import { toast } from 'react-toastify';

const InitState = {
  firstName: "",
  lastName: "",
  email: '',
  password: '',
  confirmPassword: ''
};

function Signup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryRedirect = new URLSearchParams(location.search).get('redirect');
  const redirectPath = location.state?.from || queryRedirect || "/dashboard";
  const [sForm, setSForm] = useState(InitState);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleChange = (e) => {
    setSForm({
      ...sForm,
      [e.target.name]: e.target.value
    });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleGoogleLoginSuccess = (tokenResponse) => {
    const accessToken = tokenResponse.access_token;
    dispatch(signupGoogle(accessToken, navigate, redirectPath))
      .then(() => {
        toast.success("Google signup successful");
      })
      .catch(err => {
        toast.error(err.response?.data?.message || "Google signup failed");
      });
  };

  const handleGoogleLoginError = (error) => {
    toast.error("Google signup error");
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

     // Check if all fields are filled
    if (!sForm.firstName.trim()) {
      toast.error("Please enter your first name.");
      return;
    }
    if (!sForm.lastName.trim()) {
      toast.error("Please enter your last name.");
      return;
    }
    if (!sForm.email.trim()) {
      toast.error("Please enter your email.");
      return;
    }
    if (!validateEmail(sForm.email)) {
      toast.error("Please enter a valid email.");
      return;
    }
    if (!sForm.password.trim()) {
      toast.error("Please enter your password.");
      return;
    }
    if (!sForm.confirmPassword.trim()) {
      toast.error("Please confirm your password.");
      return;
    }
    if (sForm.password.length < 4) {
      toast.error("Password must be at least 4 characters long.");
      return;
    }
    if (sForm.password !== sForm.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    if (!isChecked) {
      toast.error("You must agree to the terms and conditions.");
      return;
    }

        try {
          dispatch(signup(sForm, navigate, redirectPath));
          setSForm(InitState); // Clear form fields after signup
      } catch (err) {
          toast.error(err.response?.data?.message || "Signup failed");
      }
  
  
  };

  const login = useGoogleLogin({
    onSuccess: handleGoogleLoginSuccess,
    onError: handleGoogleLoginError
  });

    const handleGoogleClick = () => {
        if (!isChecked) {
            toast.error("You must agree to the terms and conditions before signing up with Google.");
            return;
        }
        login();
    };



  return (
    <div className={SignUp.loginContainer}>
      <div className={SignUp.loginBox}>
        {/* Left Side: Animated Headlines */}
        <div className={SignUp.loginLeftPanel}>
          <div className={SignUp.animatedTextWrapper}>
            <p className={SignUp.slideUp3} style={{ fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>
              START YOUR JOURNEY FOR 10+ SCORES
            </p>
            <h2 className={SignUp.slideUp1} style={{ fontSize: '28px', lineHeight: '1.3' }}>
              Strategy videos by Namrata Palta, author of English language books
            </h2>
            <div className={SignUp.slideUp2} style={{ fontSize: '16px', color: '#f0d9e0', marginTop: '15px' }}>
              <ul style={{ listStyleType: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <li><i className="fa-solid fa-circle-check" style={{ marginRight: '10px', color: '#ffb3c6' }}></i>Best Practice Tests</li>
                <li><i className="fa-solid fa-circle-check" style={{ marginRight: '10px', color: '#ffb3c6' }}></i>Easy Strategies & Detailed Courses</li>
                <li><i className="fa-solid fa-circle-check" style={{ marginRight: '10px', color: '#ffb3c6' }}></i>Easy Templates & Vocabulary Builders</li>
              </ul>
            </div>
            <div className={SignUp.slideUp3} style={{ marginTop: '25px', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
              <img 
                src="/girl_thumbs_up.png" 
                alt="Thumbs Up" 
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '240px', 
                  objectFit: 'contain',
                  mixBlendMode: 'lighten', /* Blends dark background into the maroon gradient */
                  WebkitMaskImage: 'radial-gradient(circle at center, black 45%, transparent 75%)',
                  maskImage: 'radial-gradient(circle at center, black 45%, transparent 75%)'
                }} 
              />
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className={SignUp.loginContainerv2}>
          <div className={SignUp.header}>
            <h1>Create your account</h1>
            <p>Sign up to get started</p>
          </div>

          <button onClick={handleGoogleClick} className={SignUp.googleBTN}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google" style={{ width: '18px', marginRight: '10px' }} />
            Sign up with Google
          </button>
          
          <span className={SignUp.or}>or</span>

          <div className={SignUp.nameRow}>
            <div className={SignUp.inputContainer}>
              <label>FIRST NAME</label>
              <input
                onChange={handleChange}
                name="firstName"
                placeholder="Enter your first name"
                type="text"
                value={sForm.firstName}
              />
            </div>
            <div className={SignUp.inputContainer}>
              <label>LAST NAME</label>
              <input
                name="lastName"
                onChange={handleChange}
                placeholder="Enter your last name"
                type="text"
                value={sForm.lastName}
              />
            </div>
          </div>
          <div className={SignUp.inputContainer}>
            <label>EMAIL</label>
            <input
              name="email"
              onChange={handleChange}
              placeholder="Enter your email"
              type="email"
              value={sForm.email}
            />
          </div>

          <div className={SignUp.inputContainer}>
            <label>PASSWORD</label>
            <div style={{ position: 'relative' }}>
              <input
                name="password"
                onChange={handleChange}
                placeholder="must be 4+ characters"
                type="password"
                value={sForm.password}
              />
            </div>
          </div>

          <div className={SignUp.inputContainer}>
            <label>CONFIRM PASSWORD</label>
            <div style={{ position: 'relative' }}>
              <input
                name="confirmPassword"
                onChange={handleChange}
                placeholder="Retype your password"
                type="password"
                value={sForm.confirmPassword}
              />
            </div>
          </div>

          {/* Terms and Conditions */}
          <div className={SignUp.termsContainer}>
            <input type="checkbox" id="tcs" onChange={handleCheckboxChange} checked={isChecked} />
            <label htmlFor="tcs">
              By clicking Register, you are agreeing to the{" "}
              <a href={process.env.NODE_ENV === 'development' ? "http://localhost:3000/terms" : "/terms"} className={SignUp.link}>T&Cs</a> and{" "}
              <a href={process.env.NODE_ENV === 'development' ? "http://localhost:3000/privacy" : "/privacy"} className={SignUp.link}>Privacy Policy</a>.
            </label>
          </div>

          <button onClick={handleOnSubmit} className={SignUp.loginBTN}>REGISTER</button>

          <span className={SignUp.notreg}>
            Already signed up? <Link className={SignUp.singupBTN} to="/login">Login</Link>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Signup;
